export const updateProperties = [
  {
    bulkType: 'STATUS',
    field: 'active',
    bulkField: 'enableStatus',
    name: 'Active',
    bulkOption: true,
    action: 'ACTIVE',
  },
  {
    bulkType: 'ARCHIVED',
    field: 'archived',
    bulkField: 'enableArchive',
    name: 'Archived',
    bulkOption: true,
    action: 'ARCHIVE_MASTER_PRODUCT',
  },
  { bulkType: 'ASSETS', field: 'assets', name: 'Assets', bulkOption: false },
  {
    bulkType: 'DESCRIPTION',
    field: 'description',
    name: 'Description',
    bulkOption: false,
  },
  {
    bulkType: 'PRICE_INCLUDES_EXCISE',
    field: 'priceIncludesExcise',
    name: 'Price Includes Excise',
    bulkOption: false,
  },
  {
    bulkType: 'PRODUCT_TYPE',
    field: 'productType',
    name: 'Product Type',
    bulkOption: true,
    action: 'PRODUCT_TYPE',
  },
  {
    bulkType: 'ONLINE_WIDGET',
    field: 'showInWidget',
    name: 'Show Online Widget',
    bulkOption: true,
    action: 'SHOW_IN_WIDGET',
  },
  {
    bulkType: 'THIRD_PARTY_MENU',
    field: 'enableWeedmap',
    name: 'Sync to 3rd Party Menus',
    bulkOption: true,
    action: 'THIRD_PART_MENUS',
  },
  {
    bulkType: 'RETAIL_PRICE',
    field: 'unitPrice',
    name: 'Retail Price',
    bulkOption: true,
    action: 'RETAIL_PRICE',
  },
  { bulkType: 'VENDOR', field: 'vendorId', name: 'Vendor', bulkOption: true, action: 'VENDOR' },
  {
    bulkType: 'SECONDARY_VENDORS',
    field: 'secondaryVendors',
    name: 'Secondary Vendors',
    bulkOption: false,
  },
  { bulkType: 'BRAND', field: 'brandId', name: 'Brand', bulkOption: false },
  {
    bulkType: 'LOW_INVENTORY_THRESHOLD',
    field: 'lowThreshold',
    bulkField: 'lit',
    name: 'Low Threshold',
    bulkOption: true,
    action: 'LOWTHRESHOLD',
  },
  { bulkType: 'TAGS', field: 'tags', name: 'Tags', bulkOption: false },
  { bulkType: 'SKU', field: 'sku', name: 'SKU', bulkOption: false },
  {
    bulkType: 'FLOWER_TYPE',
    field: 'flowerType',
    name: 'Flower Type',
    bulkOption: false,
  },
  {
    bulkType: 'CANNABIS_TYPE',
    field: 'cannabisType',
    name: 'Cannabis Type',
    bulkOption: false,
  },
  {
    bulkType: 'SAME_PRICE_MIX_MATCH',
    field: 'enableMixMatch',
    name: 'Same Price Mix & Match',
    bulkOption: true,
    action: 'SAME_PRICE_MIX_MATCH',
  },
  {
    bulkType: 'WEEDMAPS_INVENTORY_THRESHOLD',
    field: 'wmThreshold',
    name: 'Weedmaps Inventory Threshold',
    bulkOption: true,
    action: 'WEEDMAPS_INVENTORY_THRESHOLD',
  },
  {
    bulkType: 'WHOLESALE_PRICE',
    field: 'salesPrice',
    name: 'Wholesale Price',
    bulkOption: true,
    action: 'WHOLESALE_PRICE',
  },
  {
    bulkType: 'WM_ONLINE_SELLABLE',
    field: 'wmOnlineSellable',
    name: 'WM Online Sellable',
    bulkOption: true,
    action: 'WM_ONLINE_SELLABLE',
  },
]



// WEBPACK FOOTER //
// ./src/utils/catalog/masterProduct.js